import { Component, h, Host, Prop } from '@stencil/core'

@Component({
  tag: 'vds-stopper',
  styleUrl: 'vds-stopper.scss',
  shadow: true,
})
export class VdsStopper {

  /**
   * Headline
   */
  @Prop() headline: string;

  /**
   * Url of the link
   */
  @Prop() linkHref: string;

  /**
   * Label of the link
   */
  @Prop() linkLabel: string;

  /**
   * Toggles disabled status on and off
   */
  @Prop({ reflect: true, mutable: true }) disabled = false;

  /**
   * Toggles closing status on and off
   */
  @Prop({ reflect: true, mutable: true }) closing = false;

  componentWillRender(): void {
    if(localStorage.getItem('stopperClosed')) {
        this.disabled = true;
    }
    else {
        document.body.style.overflowY = "hidden";
    }
  }

  render() {
    const { headline, linkHref, linkLabel, disabled, closing } = this;

    return(
         <Host>
            <div class={{'hidden': disabled}}>
                <div class="fixed z-[1000] w-screen h-screen flex justify-end sm:justify-center bg-transparent-white">
                    <div class={{
                        'overflow-auto max-w-[400px] sm:max-w-[800px] h-full sm:h-auto bg-white my-auto border border-b-[10px] border-grey-light border-b-yellow sm:rounded-[10px] shadow-[-6px_0_10px_0_rgba(0,0,0,0.25)] sm:shadow-[10px_10px_10px_1px_rgba(0,0,0,0.15)]': true,
                        'animate-disappearRight sm:animate-disappearTop': closing
                    }}>
                        <div class="w-full flex sm:justify-end py-[22px] px-[50px] sm:pt-[15px] sm:pr-[15px] sm:pb-[8px]">
                            <button onClick={() => this.closeStopper()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.2886 30.6875L17.9961 19.395L6.70286 30.6882C6.31254 31.0785 5.67897 31.0785 5.28865 30.6882C5.09278 30.4923 4.9952 30.2363 4.99591 29.9811C4.99591 29.7251 5.09349 29.4691 5.28865 29.2739L16.5606 18.002L5.54798 6.9893C5.26945 6.71077 5.09565 6.37999 5.04168 6.06864C4.98701 5.75799 5.05177 5.46919 5.24693 5.27403C5.63725 4.88371 6.40514 5.01802 6.9622 5.57508L17.9749 16.5877L29.2893 5.27333C29.6789 4.88371 30.3117 4.883 30.7028 5.27403C31.0931 5.66436 31.0931 6.29792 30.7035 6.68754L19.4103 17.9807L30.7028 29.2732C31.0938 29.6643 31.0931 30.2971 30.7028 30.6875C30.3117 31.0785 29.6796 31.0785 29.2886 30.6875Z" fill="#D7004B"/>
                                </svg>
                            </button>
                        </div>
                        <div class="pl-[50px] pr-[50px] pb-[108px] sm:pr-[90px] sm:pb-[30px]">
                            <h3 class="text-grey text-h3-mobile sm:text-h3-tablet lg:text-h3-desktop font-heavy uppercase mb-[24px]">{ headline }</h3>
                            <div class="text-grey text-sidebar-mobile sm:text-sidebar-desktop">
                                <slot name="copy"></slot>
                            </div>
                            <vds-button class="sm:hidden mt-[20px]" color="berry" icon-behaviour="hidden" href={ linkHref } target='_blank' label={ linkLabel }></vds-button>
                            <vds-read-more class="hidden sm:block" href={ linkHref } target='_blank' label={ linkLabel }></vds-read-more>
                        </div>
                    </div>
                </div>
            </div>
        </Host>
    );
  }

  private closeStopper(): void {
    this.closing = true;
    setTimeout(() => {
        this.closing = false;
        this.disabled = true;
        localStorage.setItem('stopperClosed', 'true');
        document.body.style.overflowY = "scroll";
    }, 500);      
  }
}
